export { default } from './CollapsedBlock';
